import termsOfUseDrywall from "@public/assets/documents/terms-of-use-drywall.pdf";
import termsOfUsePedreiro from "@public/assets/documents/terms-of-use-pedreiro.pdf";
import { realityId } from "./reality-id";

export const getTermsOfUseFile = () => {
  return realityId === 1 ? termsOfUseDrywall : termsOfUsePedreiro;
};
